import React from 'react';
import { PrismicRichText } from '@prismicio/react';
import ImageTextSection from './ImageTextSection';

/**
 * @typedef {import("@prismicio/client").Content.ImageTextSlice} ImageTextSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ImageTextSlice>} ImageTextProps
 * @param { ImageTextProps }
 */
const ImageText = ({ slice }) => <ImageTextSection slice={slice} />;

export default ImageText;
